import React, { Component } from 'react';
import _ from 'underscore';
import moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import xtend from 'xtend';

const API_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const HUMAN_DATE_FORMAT = 'MM/DD/YYYY';

function getRange (data) {

    // Sort by startDateTime, oldest to newest
    var sorted = data.sort(function (a, b) {
        var c = new Date(a.startDateTime);
        var d = new Date(b.startDateTime);
        if (c < d) return -1;
        if (c > d) return 1;
        return 0;
    });

    var startDateMin = moment(
        sorted[0].startDateTime, API_DATE_FORMAT
    );

    var stopDateMax = moment(
        sorted[sorted.length - 1].startDateTime, API_DATE_FORMAT
    );

    return {
        start: startDateMin.isValid() ? startDateMin.startOf('day') : null,
        end: stopDateMax.isValid() ? stopDateMax.endOf('day') : null
    };
}

class ImporterDateFilter extends Component {
    constructor (props) {
        super(props);
        this.state = {
            start: null,
            end: null,
            edited: false
        };

        this.handleRangeChanged = this.handleRangeChanged.bind(this);
        this.reset = this.reset.bind(this);
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.csvData !== nextProps.csvData && nextProps.csvData.length > 0) {
            var range = getRange(nextProps.csvData);
            this.setState(xtend(range, { edited: false }));
            this.props.handleRangeChanged(range);
        }
    }

    handleRangeChanged (name, value) {
        if (moment.isMoment(value) && value.isValid()) {

            this.setState({
                edited: true
            });

            var updates = {};
            updates[name] = value;
            this.props.handleRangeChanged(
                xtend(
                    this.state,
                    updates
                )
            );
        }
    }

    reset (ev) {
        ev && ev.preventDefault();
        this.setState(xtend(this.state, { edited: false }));
        var updates = {
            start: this.state.start,
            end: this.state.end
        };
        this.props.handleRangeChanged(updates);
    }

    render () {
        var userDateFilter = this.props.dateFilter;
        var { start, end, edited } = this.state;

        const disabled = start === null || end === null;

        return (<div className="datePicker-wrapper__start-end">
                <label>Date</label>
                <div>
                    <ReactDatePicker
                        className="form-control"
                        minDate={start}
                        maxDate={end}
                        selected={edited ? userDateFilter.start : start}
                        disabled={disabled}
                        placeholderText="Start"
                        dateFormat={HUMAN_DATE_FORMAT}
                        onChange={this.handleRangeChanged.bind(null, 'start')}
                        />
                </div>
                <i className="fa fa-circle"/>
                <div>
                    <ReactDatePicker
                        className="form-control"
                        minDate={start}
                        maxDate={end}
                        selected={edited ? userDateFilter.end : end}
                        disabled={disabled}
                        placeholderText="End"
                        dateFormat={HUMAN_DATE_FORMAT}
                        onChange={this.handleRangeChanged.bind(null, 'end')}
                        />
                </div>
                <button
                    className="btn btn-default"
                    onClick={this.reset}
                    disabled={(edited === true ? false : true)}>
                        Reset
                </button>
            </div>);
    }
}

ImporterDateFilter.propTypes = {};

export default ImporterDateFilter;
